<template>
  <div>

    <!-- toasts message -->
    <Snackbar :SnackbarVal="SnackbarVal"></Snackbar>
    <!-- /toasts message -->

    <!--___________ Search Form _____________ -->
    <v-card>
      <v-card-title class="pb-0">
        <span class="headline">Installment Collection</span>
      </v-card-title>
      <v-form v-model="valid" ref="form" lazy-validation class="mt-0">
        <v-card-text>
          <v-container grid-list-md class="py-0">
            <v-layout wrap>
              <v-flex xs12 sm6 md6>
               <v-autocomplete
               label="Loan Number *"
               item-text="loan_no"
               item-value="id"
               v-model="formSchema.loan_id"
               :items="loanNoList"
               :rules="[v => !!v || 'Loan number is required !']"
               required
               @change="getClientName(formSchema.loan_id)"
               ></v-autocomplete>
             </v-flex>

             <v-flex xs12 sm6 md6>
                <v-text-field
                label="Sub-Project Name"
                v-model="sub_project_name"                                
                readonly
              ></v-text-field>
              </v-flex>
              
              <v-flex xs12 sm6 md6>
                <v-text-field
                label="Client Name *"
                v-model="formSchema.client_name"
                :rules="[v => !!v || 'Client name is required !']"
                required
                readonly
              ></v-text-field>
              </v-flex>

              <v-flex xs12 sm6 md6>
              <DatePicker
                :key="formSchema.id"
                :inputData="{index:1,fieldName:'from_date', fieldValue:formSchema.from_date, label:'From Date', required:''}"
                @setValue="setDateValue"
              ></DatePicker>
            </v-flex>

            <v-flex xs12 sm6 md6>
              <DatePicker
                :key="formSchema.id"
                :inputData="{index:1,fieldName:'to_date', fieldValue:formSchema.to_date, label:'To Date', required:'', disabled:'1'}"
                ref="setRange"
                @setValue="setDateValue"
              ></DatePicker>
            </v-flex>

            <v-flex xs12 sm6 md6>
              <v-autocomplete
              label="Installment Status"
              item-text="name"
              item-value="val"
              v-model="formSchema.status"
              :items="statusList"
              ></v-autocomplete>
            </v-flex>
                            
              <v-flex xs12 sm6 md4 offset-md4>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="success" @click.native="getScheduleData" :disabled="!valid">
                    <v-icon>search</v-icon>
                    Search
                  </v-btn>
                </v-card-actions>
              </v-flex>
            </v-layout>

          </v-container>
        </v-card-text>
      </v-form>
    </v-card>
    <!-- _____________/ Search Form _____________ -->

    <v-expansion-panel v-if="paidStore.length>0" x>
          <v-expansion-panel-content>
            <template v-slot:header>
              <div> <h2>PAID INSTALLMENTS</h2> </div>
            </template>
            
            <template>
              <v-card>
                <table class="paySchedule">
                  <tbody>        
                    <tr class="tb-td">
                      <td>INSTALLMENT NUMBER</td>
                      <td>INSTALLMENT DATE</td>
                      <td>OPENING PRINCIPAL</td>
                      <td>INTEREST</td>
                      <td>PRINCIPAL</td>
                      <td>INSTALLMENT SIZE</td>
                      <td>CLOSING PRINCIPAL</td>
                      <td>STATUS</td>
                      <td style="text-align:center">ACTION</td>
                    </tr>
                    <tr v-for="val in paidStore">
                      <td class="textCenter">{{val.installment_no}}</td>          
                      <td class="textCenter">{{dateStringMonth(val.installment_date)}}</td>         
                      <td class="textRight">{{numberFormate(val.opening_principal)}}</td>          
                      <td class="textRight">{{numberFormate(val.interest)}}</td>         
                      <td class="textRight">{{numberFormate(val.principal)}}</td>          
                      <td class="textRight">{{numberFormate(val.installment_amount)}}</td>         
                      <td class="textRight">{{numberFormate(val.closing_balance)}}</td> 
                      <td>
                        <span v-if="val.status == 'Paid'">
                          <v-btn small color="success" style="margin:0px">
                            Paid
                          </v-btn>
                        </span></td>         
                      <td class="textCenter">
                        <span v-if="val.status == 'Paid'">
                          <v-btn title="Edit" icon class="mx-0" @click="editRePayment(val)">
                            <v-icon color="teal">edit</v-icon>
                          </v-btn>
                        </span>
                      </td>          
                    </tr>
                  </tbody>
                </table>
              </v-card>
            </template>
          </v-expansion-panel-content>
      </v-expansion-panel> 
    </br></br>

    <!-- {{InstalmentData}} -->

    <template v-if="InstalmentData.length>0">
      <v-card>
        <table class="paySchedule">
          <tbody>        
            <tr class="tb-td">
              <td>INSTALLMENT NUMBER</td>
              <td>INSTALLMENT DATE</td>
              <td>OPENING PRINCIPAL</td>
              <td>INTEREST</td>
              <td>PRINCIPAL</td>
              <td>INSTALLMENT SIZE</td>
              <td>CLOSING PRINCIPAL</td>
              <td style="text-align:center">ACTION</td>
            </tr>
            <tr v-for="val in InstalmentData">
              <td class="textCenter" v-if="val.opening_principal>0">{{val.installment_no}}</td>          
              <td class="textCenter" v-if="val.opening_principal>0">{{dateStringMonth(val.installment_date)}}</td>         
              <td class="textRight" v-if="val.opening_principal>0">{{numberFormate(val.opening_principal)}}</td>          
              <td class="textRight" v-if="val.opening_principal>0">{{numberFormate(val.interest)}}</td>         
              <td class="textRight" v-if="val.opening_principal>0">{{numberFormate(val.principal)}}</td>          
              <td class="textRight" v-if="val.opening_principal>0">{{numberFormate(val.installment_amount)}}</td>         
              <td class="textRight" v-if="val.opening_principal>0">{{numberFormate(val.closing_balance)}}</td>          
              <td class="textCenter" v-if="val.opening_principal>0">
                <span v-if="val.status == 'Paid'">
                  <v-btn small color="success" style="margin:0px">
                    Paid
                  </v-btn>
                </span>
                <span v-else>
                                    
                  <!-- 
                    It was active confition before UAT3 session
                    <template v-if="val.installment_no>0"> -->

                    <!-- Add confition after UAT3 Session -->
                    <template v-if="val.installment_amount>0"> 

                    <!-- {{val.interest_type}} -->

                      <!-- Start from UAT 3rd 22/07/2020 session  -->
                     <v-btn title="Re-Payment" @click="rePayment(val)" small color="info" style="margin: 0px;margin-top: 4px;">
                        Re-Payment
                      </v-btn> 
                      <!-- /Start from UAT 3rd 22/07/2020 session  -->

                    
                    <!-- Stop from UAT 3rd 22/07/2020 session -->
                    <!-- <template v-if="val.interest_type == 'Fixed'">
                      <v-btn title="Re-Payment" @click="rePayment(val)" small color="info" style="margin: 0px;margin-top: 4px;">
                        Re-Payment
                      </v-btn> 
                    </template>
                    
                    <template v-else>
                      <span v-if="val.rs_date == 1">
                        <v-btn title="Re-Payment" @click="rePayment(val)" small color="info" style="margin: 0px;margin-top: 4px;">
                          Re-Payment
                        </v-btn>                  
                      </span>

                      <span v-else>
                        <v-btn :title="`Reset Date ${dateStringMonth(val.compairDate)}`"  small color="warning" style="margin:0px" @click="loanReset(val)">
                          Loan Reset <v-icon>attach_money</v-icon>
                        </v-btn>
                      </span>
                    </template>  -->

                  </template>
                  
                </span>
              </td>          
            </tr>
          </tbody>
        </table>
      </v-card>
    </template>
    
  </div>
</template>

<script>



let commonService = require("../../../services/common.service");
let UtilService = require("../../../services/util.service");
import DatePicker from "../../global/date_picker";

export default {
  components: {
    DatePicker
  },
  data() {
    return {
      valid:true,
      e1: 0,
      InstalmentData:[],
      paidStore:[],
      loanNoList:[],
      sub_project_name:"",
      statusList:[
        {
          val:'',
          name:'All',
        },
        {
          val:'Paid',
          name:'Paid',
        },
        {
          val:'Unpaid',
          name:'Unpaid'
        },
      ],

      formSchema: {
        loan_id: "",
        client_name:"",
        from_date:"",
        to_date:"",
        status:"",
      },

      SnackbarVal: {
        snackbar: false,
        color: "success",
        message: ""
      },

    };
  },
  created() {
    commonService.getAllData("get-disbursmented-loan-ids").then(res => {        
      this.loanNoList = res.loanNoList;
    });
  },

  methods:{

    numberFormate(numBer)
    {
      if(numBer != '-')
      {
        return Math.round(numBer).toLocaleString()+'.00';
      }
      else
      {
       return '0.00'; 
      }
    },

    getScheduleData()
    {
      let formSchema = this.formSchema

      if(formSchema.from_date !="" )
      {
        formSchema.from_date = this.changeFormateYMD(
          formSchema.from_date
          );
      }
      if(formSchema.to_date !="" )
      {
        formSchema.to_date = this.changeFormateYMD(
          formSchema.to_date
          );
      }

      if (this.$refs.form.validate()) {  

        if(formSchema.loan_id != '')
        {
          commonService.dataByMulParameters(formSchema, "get-loan-schedule-data").then(res => {
            if(res.arSize > 0)
            {              
              this.InstalmentData = res.data;
              this.paidStore = res.paidStore;             
            }
            else
            {   
              this.InstalmentData = [];
              this.SnackbarVal.color = 'error';
              this.SnackbarVal.message = 'Payment schedule is empty';
              this.SnackbarVal.snackbar = true;
            }
          });
        }
        else
        {
          this.SnackbarVal.color = 'error';
          this.SnackbarVal.message = 'Loan number is empty!';
          this.SnackbarVal.snackbar = true;
        }
      }
    },

    rePayment(items)
    {
      console.log('items', items);
      this.$store.commit('SET_RE_PAYMENT_DATA', items);
      this.$router.push("/on-lending/re-payment");
    },

    editRePayment(items)
    {
      items.is_edit = true;
      console.log('items', items);
      this.$store.commit('SET_RE_PAYMENT_DATA', items);
      this.$router.push("/on-lending/re-payment");
    },

    overdueInst(items)
    {
      this.$store.commit('SET_RE_PAYMENT_DATA', items);
      this.$router.push("/on-lending/overdue-intnstallment-payment");
    },

    getClientName(loan_id){

      let Loan = this.loanNoList.filter(function(a) {
        return a.id == loan_id;
      })[0];
      this.InstalmentData = [];
      this.formSchema.client_name  = Loan.client_name;      
      this.sub_project_name  = Loan.sub_project_name;

    },

    setDateValue(data) {
      let index = data.index;
      this.formSchema[data.fieldName] = (data.value != null) ? data.value : "";

      if(data.fieldName == 'from_date'){
        this.formSchema.to_date = 0
        this.$refs.setRange.setRange(data.value);
      }
    },

    loanReset(items){
      this.$store.commit('SET_RE_PAYMENT_DATA', items);
      this.$router.push("/on-lending/search-loan-reset");
    }
    
  },

};
</script>

<style>
table.paySchedule{
  width:100%;
  border-collapse: collapse;
}
.paySchedule td{
  border:1px solid #CCC;
  padding: 6px;
}
.paySchedule tr.tb-td td{
  font-weight: bold;
}
td.textCenter{
  text-align: center;
}
td.textRight{
  text-align: right;
}
</style>


// WEBPACK FOOTER //
// src/components/lending/installmentCollection/dataTable.vue